import {map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Unit, UnitModel} from '../../dashboard/monitoring/unit';
import {AppInitService} from '../../app-init.service';
import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class UnitImageService {

  constructor(
    protected http: HttpClient,
    protected appInit: AppInitService,
  ) {
  }

  getDefaultImage(unit_type_name: string): any {
    return this.appInit.customizationConfig.color_scheme_name === undefined
    || this.appInit.customizationConfig.color_scheme_name === 'color' // default color scheme
      ? {
        image: 'assets/img/' + unit_type_name + '.svg',
        title: 'No unit model picture'
      } : {
        image: 'assets/img/sprites-theme/'
          + this.appInit.customizationConfig.color_scheme_name
          + '/' + unit_type_name + '.svg',
        title: 'No unit model picture'
      };
  }

  getUnitModelImage(unit: Unit) {
    const params = (new HttpParams()).append('fields', 'unit_type_name,image_base64');
    return this.http.get(
      environment.apiBasepoint + 'unit-model/' + unit.unit_model_id.toString(),
      {params: params, observe: 'body'}
    ).pipe(
      map((unitModel: UnitModel) => {
        return unitModel.image_base64 ? {image: 'data:image/jpeg;base64,' + unitModel.image_base64, title: ''}
          : this.getDefaultImage(unit.unitModel.unit_type_name);
      })
    );
  }
}
